import type { ClientValueHistory } from "@repo/shared/types";
import { get } from "./_client";

/** The client's total value week by week, in the tenant currency (QL-356). */
export function getClientValueHistory(clientId: string) {
  return get<ClientValueHistory>(`/internal/client-accounts/${clientId}/value-history`);
}
